import { FeedbackLabelType } from 'v2/core/entities/feedback';
import { EntityLabel as FeedbackEntityLabel } from 'v2/core/entities/feedback/labels';
import { EntityLabel } from 'v2/core/entities/labels';

export const mapTaxonomyEntityLabelToFeedbackEntityLabel = (
  label: EntityLabel,
): FeedbackEntityLabel => {
  return {
    id: label.id,
    displayName: label.name,
    isVisible: label.isVisible,
    type: FeedbackLabelType.Entity,
    createdAt: label?.createdAt,
  };
};
